import { ChefHat } from 'lucide-react';

import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const PreparationStationEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={ChefHat}
      title="No hay estaciones configuradas"
      description="Cree áreas como cocina, bar, postres o empaque para enrutar comandas y responsables de preparación."
      hint="Use Nueva estación para crear la primera área"
    />
  );
};

export default PreparationStationEmpty;
